/**
 * Microstates and small territories that can be hidden on the world map.
 * Used by Map.js for visibility and by DataIntergration for the custom modal.
 */

export const MICROSTATES_LIST = [
  { code: "AD", name: "Andorra" },
  { code: "AX", name: "Åland Islands" },
  { code: "CY", name: "Cyprus" },
  { code: "FO", name: "Faroe Islands" },
  { code: "GI", name: "Gibraltar" },
  { code: "GG", name: "Guernsey" },
  { code: "IM", name: "Isle of Man" },
  { code: "JE", name: "Jersey" },
  { code: "LI", name: "Liechtenstein" },
  { code: "MC", name: "Monaco" },
  { code: "MT", name: "Malta" },
  { code: "SM", name: "San Marino" },
  { code: "VA", name: "Vatican City" },
  { code: "HK", name: "Hong Kong" },
  { code: "MO", name: "Macao" },
  { code: "SG", name: "Singapore" },
  { code: "AG", name: "Antigua and Barbuda" },
  { code: "AI", name: "Anguilla" },
  { code: "AW", name: "Aruba" },
  { code: "BL", name: "Saint Barthélemy" },
  { code: "BM", name: "Bermuda" },
  { code: "BQ", name: "Caribbean Netherlands" },
  { code: "CW", name: "Curaçao" },
  { code: "DM", name: "Dominica" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "KY", name: "Cayman Islands" },
  { code: "LC", name: "Saint Lucia" },
  { code: "MF", name: "Saint Martin" },
  { code: "MS", name: "Montserrat" },
  { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "SX", name: "Sint Maarten" },
  { code: "TC", name: "Turks and Caicos Islands" },
  { code: "VC", name: "Saint Vincent and the Grenadines" },
  { code: "VG", name: "British Virgin Islands" },
  { code: "VI", name: "U.S. Virgin Islands" },
  { code: "AS", name: "American Samoa" },
  { code: "CK", name: "Cook Islands" },
  { code: "FM", name: "Micronesia" },
  { code: "GU", name: "Guam" },
  { code: "KI", name: "Kiribati" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NR", name: "Nauru" },
  { code: "NU", name: "Niue" },
  { code: "PF", name: "French Polynesia" },
  { code: "PW", name: "Palau" },
  { code: "SB", name: "Solomon Islands" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TV", name: "Tuvalu" },
  { code: "VU", name: "Vanuatu" },
  { code: "WF", name: "Wallis and Futuna" },
  { code: "WS", name: "Samoa" },
  { code: "CV", name: "Cabo Verde" },
  { code: "KM", name: "Comoros" },
  { code: "MV", name: "Maldives" },
  { code: "MU", name: "Mauritius" },
  { code: "RE", name: "Réunion" },
  { code: "SC", name: "Seychelles" },
  { code: "ST", name: "São Tomé and Príncipe" },
  { code: "YT", name: "Mayotte" },
  { code: "FK", name: "Falkland Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "SH", name: "Saint Helena" },
  { code: "SJ", name: "Svalbard and Jan Mayen" },
];

export const MICROSTATE_CODES = new Set(MICROSTATES_LIST.map((m) => m.code));
